
export default class GridSaveMeta {
    /**
     * @param {string} gridKey
     * @param {number} gridCol
     * @param {number} gridRow
     */
    constructor(gridKey, gridCol, gridRow) {
        /**
         * @constant
         * @type {string}
         */
        this.gridKey = gridKey;
        /**
         * @constant
         * @type {number}
         */
        this.gridCol = gridCol;
        /**
         * @constant
         * @type {number}
         */
        this.gridRow = gridRow;
    }
}